<div class="offcanvas-header">
	<h3 class="offcanvas-title">Update Inventory Category</h3>
	<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<hr class="mx-3" />
<div class="offcanvas-body">
	<div class="body">
		<div class="form-container">
			<app-standard-control type="text" name="name" [formGroup]="form" label="Name" placeholder="Name"></app-standard-control>

			<app-textarea-control
				[resizable]="true"
				[heightPx]="200"
				name="description"
				[formGroup]="form"
				label="Description"
				placeholder="Description"
			></app-textarea-control>

			<app-switch-control [formGroup]="form" name="archived" label="Archived"></app-switch-control>
		</div>
	</div>

	<div class="footer">
		<div class="actions">
			<div class="buttons">
				<button
					type="button"
					class="btn btn-sm btn-primary"
					(click)="submit()"
					[disabled]="form.invalid || form.pristine || isSubmitting"
				>
					<ng-container *ngIf="isSubmitting; else notLoading">
						<div class="spinner-border spinner-border-sm" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					</ng-container>
					<ng-template #notLoading> Update Category </ng-template>
				</button>
			</div>
		</div>
	</div>
</div>
